<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              Designing a greater university experience for graduate students to become
              proficient in research and achieve academic success.
            </p>
          </div>
        </div>-->

        <div class="uk-padding  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h1 class="uk-heading-line uk-text-center specHeading uk-text-bold">Office of Graduate Studies</h1>
            <br/>
            <div uk-grid>
              <div  class="uk-width-2-3@m">
                <p>Welcome to the graduate community at Northern Caribbean University.</p>
                <p>The Graduate Studies Office is committed to producing leaders for Jamaica and the global
                  environment. Excellence, Leadership, stewardship, Christ-centeredness, collaboration, diversity,
                  innovation, integrity, respect, responsibility, affirmation and service are core values that each of
                  our students exemplifies.
                </p>
                <p>
                  It is the aim of the Office to develop scholars and professionals who will be engaged in
                  providing solutions to global problems. Graduate education is part of the University’s mission
                  and the area will strive to produce solutions to get a deeper understanding of spiritual, natural,
                  cultural, imaginative, social and technological needs. The Office of Graduate Studies is
                  committed to give support to students so that they can achieve their academic or professional
                  goals.
                </p>
                <p>
                  The Office gives oversight to all graduate programmes to ensure that they function effectively
                  and produce quality graduates for Jamaica and the world. The Graduate area will provide
                  assistance to the daily needs of our students as they advance through their graduate programmes.
                </p>
                <p>
                  Central to the operation of this department is the growth of graduate programmes and scholarly
                  activities. The graduate programme of the university has grown steadily over the past 18 years
                  and has produced graduates that are playing key roles in shaping and modernizing societies
                  locally and internationally. We continue to build on the tradition of excellence and to produce
                  professionals who can advance and manage in a developed world. The eminence in research is
                  very important in the execution of the Strategic Plan for Northern Caribbean University.
                </p>
                <p>
                  Northern Caribbean University is committed to conducting world class research that impacts the
                  communities and improve lives. We are an institution committed to quality Christian service.
                  Special welcome to you all. Please feel free to contact our staff if you have questions or need
                  clarifications. The Graduate Office is available to serve all who desire quality Graduate
                  Education.
                </p>
               <span class="uk-text-small">
                  Sincerely, <br>
                Professor Paul Gyles, Ph.D. <br>
                Dean for Graduate Studies <br>
                Northern Caribbean University <br>
                Mandeville, Jamaica
               </span>
              </div>

              <div class="uk-width-1-3@m">
                <div >
                  <div class="uk-child-width-1-2@s uk-child-width-1-1@l " uk-grid>
                    <div>
                      <img class="uk-border-circle" src="/pg.jpg" width="200" height="200" alt="Border circle">
                    </div>
                    <div>
                      <img class="uk-border-circle" src="../assets/grad2.jpg" width="200" height="200" alt="Border circle">
                    </div>
                  </div>
                </div>
                <br>
                <div>
                  <div class=" uk-child-width-1-1@l uk-child-width-1-2@s" uk-grid>
                    <div>
                      <img class="uk-border-circle" src="../assets/grad3.jpg" width="200" height="200" alt="Border circle">
                    </div>
                    <div class="uk-hidden@m">
                      <img class="uk-border-circle" src="../assets/grad1.jpg" width="200" height="200" alt="Border circle">
                    </div>

                  </div>
                </div>

              </div>

            </div>
            <br>
            <router-link class="uk-button uk-button-secondary uk-align-right" to="/gradprograms" style="color: rgb(197,179,88) !important;">See Graduate Programmes >></router-link>
          </div>
          <br/>
          <div class="uk-section uk-section-default">
            <div class="uk-container-small uk-align-center">


              <div class="uk-grid-match uk-child-width-1-3@m" uk-grid>
                <div>
                  <div>
                    <h3 class="uk-heading-bullet uk-text-bold">Mission Statement</h3>
                    <p>The mission of the Office of Graduate Studies is to serve an
                      international clientele in a Caribbean setting, to prepare individuals for
                      excellence in thinking, research, and committed service in response to
                      the diverse needs of a global environment, and within the
                      framework of a Seventh-day Adventist worldview.
                    </p>
                  </div>
                </div>
                <div>
                  <div>
                    <h3 class="uk-heading-bullet uk-text-bold">Vision Statement </h3>
                    <p>Helping to move the institution from good to
                      great through teaching, research, writing,
                      publication, and public service.
                    </p>
                  </div>
                </div>
                <div>
                  <div>
                    <h3 class="uk-heading-bullet uk-text-bold">Value Statement</h3>
                    <p>
                      Creating critical, ethical, and competent
                      leadership qualities in all
                      our professionals.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="uk-padding uk-remove-top uk-background-muted">
          <div class="uk-container uk-container-small">

            <h3 class="uk-heading-bullet specHeading">Research </h3>

            <div class="uk-child-width-1-1@m" uk-grid>
              <div>
                <p>The Office of Research is the primary agent of the University’s current thrust to foster research.
                  It monitors all matters affecting the integrity of research and the impact of statutory regulations and policies.
                  The policies and procedures constitute the official policy that governs the conduct of research at this University.
                  The office is organized to be consistent with general university policy affecting all facet of the University.
                  When adhered to, the procedures outlined will ensure that research proposals are scientifically sound,
                  relevant to society’s needs, and not duplicative of effort undertaken elsewhere.</p>
              </div>
              <div class="uk-child-width-1-2@m" uk-grid>


                <div class="uk-margin-top ">
                  <a href="../../../ncu_general_disclosure_form.doc" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">General Disclosure Form
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>
                <div class="uk-margin-top">
                  <a href="../../../NORTHERN%20CARIBBEAN%20UNIVERSITY%20Invention%20Disclosure%20Form.doc" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">Invention Disclosure Form
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>
                <div class="uk-margin-top">
                  <a href="../../../IRBApplicationFormUpdatedAugust2019.doc" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">IRB Human Subjects Application Form
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>
                <div class="uk-margin-top">
                  <a href="../../../research-policy-procedures-manual-2014.pdf" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">Research Policy & Procedures Manual
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>



              </div>
              <div class="uk-width-1-1">
                <div class="uk-margin-top ">
                  <a href="../../../guidelines-for-the-submission-of-theses-and-dissertations.pdf" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">Guidelines for the Submission of Master’s Theses and Doctoral Dissertations
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>
                <div class="uk-margin-top">
                  <a href="../../../irb-pathogenic-or-hazardous-substances-and-dangerous-drugs-application-form-2014.doc" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">IRB Pathogenic or Hazardous Substances and Dangerous Drugs Application Form
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>
                <div class="uk-margin-top">
                  <a href="../../../irb-non-human-vertebrate-animal-application-form-2014.doc" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">IRB Non-Human Vertebrate Animal Application Form
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

       <!-- <article class="uk-article">
          <div uk-grid>
            <div class="uk-width-1-5@l"></div>
            <div class="uk-width-3-5@l">
              <div class="uk-card">
                <div class="uk-card-media-top">
                  <img src="../../assets/PaulGyles.png" alt="">
                </div>
                <div class="uk-card-body">
                    <p class="">
                      The University Administration welcomes  you to the Department of Research and Graduate Studies website.
                      This department is responsible for ensuring adherence to the policies of the university and the policies
                       outlined by research sponsors. It also ensures that ethical standards in conducting research are maintained.
                        We also provide guidance and direction in the identification and development of projects and funding sources
                         for faculty members.
                    </p>
                    <p class="">
                      Other functions of the department include facilitating faculty members in obtaining external research funding,
                       managing internal research-funded projects, promoting involvement in research among faculty and with students,
                       expediting undergraduate and graduate research, overseeing the process for the implementation of new graduate
                       programmes, and providing assistance for the daily needs of our students as they advance through their graduate
                        programmes.
                    </p>
                    <p class="">
                      Central to the operation of this department is the growth of graduate programmes and scholarly activities.
                      The graduate programme of the university has grown steadily over the past 18 years and has produced graduates
                      that are playing key roles in shaping and modernizing societies locally and internationally. We continue to
                      build on the tradition of excellence and to produce professionals who can advance and sustain a developed world.
                        The eminence in research is very important in the execution of the Strategic Plan.
                    </p>
                    <p class="">
                      Northern Caribbean University is committed to conducting world class research that impacts the communities
                       and improve lives. We are an institution committed to quality Christian service. Special welcome to you all.
                       Please feel free to contact our staff if you have questions or need clarifications.
                    </p>
                  <div class=" uk-width-1-5@l">
                    <p class=" uk-text-muted specHeading uk-article-meta">
                      Sincerely,
                      Professor Paul Gyles, Ph.D.
                      Vice-President of Research and
                      Dean for Graduate Studies
                      Northern Caribbean University
                      Mandeville, Jamaica
                      </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>-->

        <div class="uk-padding  uk-remove-top">
          <div class="uk-container uk-container-small">
            <h2 class="uk-heading-line uk-text-center specHeading">Important Policies and Forms</h2>
            <h3 class="uk-heading-bullet specHeading">Academics </h3>

            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                <p>The Northern Caribbean University (NCU) sets out the expectations of students and the University through policies regarding academic engagement,
                  integrity, behaviour and well-being. Our academic policies are designed to provide the highest quality education and service to our students.
                  They are developed to guide the interaction with, and service to students.
                  The following information is intended to offer clarification of certain university academic policies.
                  While not all University policies are addressed, we hope to elucidate some policies pertaining to all students and faculty,
                  and offer information and guidance on the procedures related to these policies.</p>
              </div>
              <div >
                <div class="">
                  <a href="../../../intellectual_property_policy.pdf" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">Intellectual Property
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>
                <div class="uk-margin-top">
                  <a href="../../../ResearchPolicyProceduresManual2019Updated.pdf" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">Research Policy & Procedures Manual
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>

                <div class="uk-margin-top">
                  <a href="../../../Ranking_Document_Revised_Fall_2013.pdf" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">Guide to Advancement In Rank
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>
                <div class="uk-margin-top">
                  <a href="../../../Standards%20for%20Written%20Work_2017.pdf" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">NCU Standards for Written Work
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>
                <div class="uk-margin-top">
                  <a href="../../../certification_of_completion_form.pdf" target="_blank" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">Certification of Completion Form
                    <span class="uk-margin-small-right" uk-icon="icon: download; ratio: 1.5" style="color: rgb(197,179,88) !important;"></span>
                  </a>
                </div>
                <div class="uk-margin-top">
                  <router-link to="/gradprograms" class="uk-button uk-button-secondary uk-width-1-1" style="color: rgb(197,179,88) !important;">Graduate Programmes </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        name: "ogsr",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Office of Research and Graduate Studies',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Department of Research and Graduate Studies at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>

</style>
